import { useState, useCallback, useEffect } from 'react'

const ONBOARDING_KEY = 'cvtoday_onboarding_completed'

export function useOnboarding() {
  const [hasCompletedOnboarding, setHasCompletedOnboarding] = useState<boolean | null>(null)

  useEffect(() => {
    const completed = localStorage.getItem(ONBOARDING_KEY) === 'true'
    setHasCompletedOnboarding(completed)
  }, [])

  const completeOnboarding = useCallback(() => {
    localStorage.setItem(ONBOARDING_KEY, 'true')
    setHasCompletedOnboarding(true)
  }, [])

  return { hasCompletedOnboarding, completeOnboarding }
}
